/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';

function SnackbarUIComponent({ uistate }) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (
      uistate.currentState &&
      uistate[uistate.currentState] &&
      uistate[uistate.currentState].message
    ) {
      const key = enqueueSnackbar(uistate[uistate.currentState].message, {
        preventDuplicate: true,
        variant: uistate.currentState,
        action: key => (
          <>
            <IconButton id={`snackbar-${uistate.currentState}`} onClick={() => closeSnackbar(key)}>
              <CloseIcon />
            </IconButton>
          </>
        ),
      });
    }
    // eslint-disable-next-line
  }, [uistate]);

  return <></>;
}

export { SnackbarUIComponent };
